import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SiteHeader from '../components/layout/SiteHeader';
import SiteLayout, { SiteMain } from '../components/layout/SiteLayout';

/**
 * Legacy route - M-Pesa checkout completes on /checkout/:paymentId step 3.
 */
const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  useEffect(() => {
    if (paymentId) {
      window.location.replace(`/checkout/${paymentId}`);
    }
  }, [paymentId]);

  return (
    <SiteLayout className="bg-gray-50">
      <SiteHeader />
      <SiteMain className="flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment successful</h1>
          <p className="text-gray-600 mb-6">
            Your tickets have been sent to your email. You can also view them from the link on the checkout page.
          </p>
          <Link to="/events" className="inline-block bg-gray-900 text-white px-6 py-3 rounded-lg font-medium">
            Browse more events
          </Link>
        </div>
      </SiteMain>
    </SiteLayout>
  );
};

export default PaymentSuccessPage;
